import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, SimpleChanges, SimpleChange } from '@angular/core';
import { NumericDataElement } from '../../../core/elements/models/numeric-data-element.model';
import { NumericElement } from '../assist-data-element.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectedCondition } from '../../../core/models/executed-result.model';
import { SimulatorEngineService } from '../../../core/services/simulator-engine.service';
import { SimulatorCommunicationService } from '../../shared/services/simulator-communication.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'acr-assist-numeric-element',
  template: `<form [formGroup]="numericElementForm" novalidate>
  <div class="form-group">
    <div class="col-sm-5 text-right">
      <label class="control-label break-word">
        {{numericDataElement.label}}
        <span *ngIf="numericDataElement.unit != undefined && numericDataElement.unit != ''"> ({{numericDataElement.unit}})</span>
      </label>
      <ng-container *ngIf="numericDataElement.hint !== '' && numericDataElement.hint !== undefined">
        <i class="fa fa-info-circle text-primary whitespace" title="{{numericDataElement.hint}}"></i>
      </ng-container>
      <ng-container *ngIf="numericDataElement.diagrams != undefined ">
        <acr-hint-diagram [dataElement]="numericDataElement" [imagePath]="imagePath"></acr-hint-diagram>
      </ng-container>
      <ng-container *ngIf="this.numericDataElement.isRequired">
        <span *ngIf="numericElementForm.controls['numericElement'].invalid">
          <span *ngIf="numericElementForm.controls['numericElement'].errors.required" class="required-field" title="Required Field">
            *
          </span>
        </span>
      </ng-container>
      <span *ngIf="numericElementForm.controls['numericElement'].invalid && numericElementForm.controls['numericElement'].errors.min"
        class="required-field" title=" Minimum value is {{numericDataElement.minimum}}">
        *
      </span>      
      <span *ngIf="numericElementForm.controls['numericElement'].invalid && numericElementForm.controls['numericElement'].errors.max"
        class="required-field" title=" Maximum value is {{numericDataElement.maximum}}">
        *
      </span>
    </div>
    <ng-container *ngIf="numericDataElement.dataElementType === 'NumericDataElement'">
      <div class="col-sm-7">
        <input [attr.disabled]="numericDataElement.isEditable == false ? 'disabled' : null" acrNumericOnly [(ngModel)]="numberValue" id="{{numericDataElement.id}}" type="text" class="form-control" formControlName="numericElement"
          onpaste="return false;" (input)="choiceSelected($event.target, numericDataElement.label)"
          min="{{numericDataElement.minimum}}" max="{{numericDataElement.maximum}}" required>          
      </div>
    </ng-container>
    <ng-container *ngIf="numericDataElement.dataElementType === 'IntegerDataElement'">
      <div class="col-sm-7">
        <input [attr.disabled]="numericDataElement.isEditable == false ? 'disabled' : null" [(ngModel)]="numberValue" id="{{numericDataElement.id}}" type="text" class="form-control" formControlName="numericElement"
          (keypress)="onlyIntegerKey($event)" onpaste="return false;" (input)="choiceSelected($event.target, numericDataElement.label)"
          min="{{numericDataElement.minimum}}" max="{{numericDataElement.maximum}}" required>
      </div>
    </ng-container>
  </div>
</form>
`,
  styles: [``, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})
export class AssistNumericElementComponent implements OnInit, AfterViewInit {
  subscription: Subscription;
  @Input() numericDataElement: NumericDataElement;
  @Input() imagePath: string;
  @Output() returnNumericElement = new EventEmitter();
  numericElementForm: FormGroup;
  selectedCondition: SelectedCondition;
  numberValue: number;
  constructor(private formBuilder: FormBuilder, private simulatorEngineService: SimulatorEngineService,
    simulatorCommunicationService: SimulatorCommunicationService) {
    this.subscription = simulatorCommunicationService.simulatorSource$.subscribe(
      mission => {
        this.UpdateFormValidator();
      });
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.createNumericElementForm();
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    // console.log('asda');
  }

  ngAfterViewInit(): void {
    if (this.numericDataElement.currentValue !== undefined && this.numericDataElement.currentValue !== 0) {
      this.simulatorEngineService.addOrUpdateDataElement(this.numericDataElement.id, this.numericDataElement.currentValue,
        this.numericDataElement.currentValue);
      this.numberValue = this.numericDataElement.currentValue;
      this.loadedNumericValue(this.numericDataElement.id, this.numericDataElement.currentValue, this.numericDataElement.label);
    } else {
      this.returnNumericElement.emit(undefined);
    }
  }

  loadedNumericValue(id, value, selectedCondition) {
    const choiceElement = new NumericElement();
    choiceElement.elementId = id;
    choiceElement.selectedValue = value;

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = id;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = value;
    this.returnNumericElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
  }

  choiceSelected(element, selectedCondition) {
    const choiceElement = new NumericElement();
    choiceElement.elementId = element.id;
    choiceElement.selectedValue = element.value;

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = element.id;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = element.value;
    this.returnNumericElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
  }

  onlyIntegerKey(event) {
    return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  private createNumericElementForm() {
    this.numericElementForm = this.formBuilder.group({
      numericElement: ['', Validators.compose([Validators.required, Validators.min(+this.numericDataElement.minimum), Validators.max(+this.numericDataElement.maximum)])],
    });
  }

  UpdateFormValidator() {
    this.numericElementForm.controls['numericElement'].setValidators([Validators.compose([Validators.required,
    Validators.min(+this.numericDataElement.minimum), Validators.max(+this.numericDataElement.maximum)])]);
    this.numericElementForm.controls['numericElement'].updateValueAndValidity();
  }
}
